import { useEffect, useState } from "react";

import { SearchIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import GlobalSearchForm from "@/shared/components/GlobalSearchForm";

interface Props {
  permissions: string[];
}

export default function GlobalSearchBar({ permissions }: Props) {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setSearchOpen((prev) => !prev);
      }
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <>
      <GlobalSearchForm open={searchOpen} onOpenChange={setSearchOpen} permissions={permissions} />
      <div className="hidden flex-1 items-center justify-center md:flex">
        <button onClick={() => setSearchOpen(true)} className="flex h-8 w-full max-w-xs items-center gap-2 border border-input bg-muted px-3 text-xs text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
          <SearchIcon className="size-3.5 shrink-0" />
          <span className="flex-1 text-left">Search projects & tickets…</span>
          <kbd className="hidden items-center gap-0.5 rounded border border-border bg-background px-1.5 py-0.5 font-mono text-[10px] sm:flex">
            <span>⌘</span>K
          </kbd>
        </button>
      </div>
      <div className="flex flex-1 justify-end md:hidden">
        <Button variant="ghost" size="icon-sm" aria-label="Search" onClick={() => setSearchOpen(true)}>
          <SearchIcon className="size-4" />
        </Button>
      </div>
    </>
  );
}
